import {
  loopbackDelete,
  loopbackGet, loopbackPost, loopbackPut,
} from '..';
import {
  BillingAddress, PartialBy,
} from '../../redux/types';

export const addBillingAddress = (data: PartialBy<BillingAddress, 'id'>): Promise<BillingAddress> => {
  if (!data.id) {
    return loopbackPost('BillingAddresses/addBillingAddress', data);
  }
  return loopbackPut(`BillingAddresses/${data.id}`, data);
};

export const getBillingAddress = (): Promise<BillingAddress[]> => loopbackGet('BillingAddresses/getUsersBillingAddresses');

export const deleteBillingAddress = (id: number): Promise<unknown> => loopbackDelete(`BillingAddresses/${id}`);
